
// RoomBookingTypeLists.js
import { getData, postData, putData, deleteData } from "../apiClient";

// Get booking types with pagination
export const getBookingTypesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/booking-type/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Booking Types with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// Get single booking type by ID
export const getBookingTypeById = async (id) => {
    try {
        const result = await getData(`/booking-type/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Booking Type data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// Create booking type
export const createBookingType = async ({ data }) => {
    try {
        const result = await postData(`/booking-type/create-booking-type`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create Booking Type API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// Update booking type
export const updateBookingType = async ({ id, data }) => {
    try {
        const result = await putData(`/booking-type/update-booking-type/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Update Booking Type API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// Delete booking type
export const deleteBookingType = async ({ id }) => {
    try {
        const result = await deleteData(`/booking-type/delete-booking-type/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Delete Booking Type API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};